/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import EnvironmentService from 'cio/services/environment';
import AuthService from 'cio/services/auth';
import RelationshipCondition from 'cio/app-models/conditions/relationship';
import ObjectAttributeCondition from 'cio/app-models/conditions/object-attribute';

interface CioConditionEditorRelationshipArgs {
  // backwards compat
  classNames: string;
  condition: RelationshipCondition;
  allowMessageWildcardSelection?: boolean;
  allowInParentWildcardSelection?: boolean;
  inverseOptions: { value: boolean; label: string }[];
  depth: number;
  actionItems: { value: boolean; label: string }[];
  customerItems: { value: boolean; label: string }[];
  changetype: () => unknown;
  onRemove: () => unknown;
  disabled: boolean;
}

export default class CioConditionEditorRelationship extends Component<CioConditionEditorRelationshipArgs> {
  @service auth!: AuthService;
  @service environment!: EnvironmentService;

  previousInverseValue = this.args.condition.inverse;
  temporaryConditionFilters = [] as ObjectAttributeCondition[];

  get isRefined() {
    let { filters } = this.args.condition;

    return filters.length > 0;
  }

  @computed('args.condition.{inverse,filters}')
  get filters() {
    let { inverse, filters } = this.args.condition;

    // this happens initially and when only filters value changes
    if (inverse === this.previousInverseValue) {
      return filters;
    }

    if (filters.length > 0) {
      this.temporaryConditionFilters = filters;
    }

    // refining and adding filters can only happen if inverse is false
    if (this.previousInverseValue && !inverse) {
      // if user switches between true and false inverse values we want to preserve their work or initial filters
      this.args.condition.filters = [...this.temporaryConditionFilters];
    } else if (inverse) {
      this.args.condition.filters = [];
    }

    this.previousInverseValue = inverse;
    return this.args.condition.filters;
  }

  @action
  addFilter() {
    let objectTypeId = this.args.condition.typeId ?? null;
    let filter = ObjectAttributeCondition.create({
      objectTypeId,
      name: '',
      operator: 'eq',
      value: '',
    });

    this.args.condition.filters = [...this.args.condition.filters, filter];
  }

  @action
  removeFilter(filter: ObjectAttributeCondition) {
    this.args.condition.filters = this.args.condition.filters.filter((f) => f !== filter);
  }
}
